<div class="chat-ms_container" [style.grid-template-rows]="gridTemplateRows()" [style.--chat-background-image]="backgroundImageStyle()">
  @if(showHeader()) {
    <div class="chat-ms_header"
      [class.justify-content-between]="contactNamePosition() === 'left'"
      [class.justify-content-end]="contactNamePosition() === 'right'">
      <div class="chat-ms_desc-user align-items-center">
        <div class="chat-ms_user-img" [style.order]="contactNamePosition() === 'left' ? '0' : '1'">
          <img [src]="avatarUrl()" alt="" />
        </div>
        <div class="chat-ms_user-connection">
          <p class="user" [style]="textStyle()">{{ contactName() }}</p>
        </div>
      </div>
      @if (enableCarousel()) {
        <div class="header-actions">
          @if(headerButton(); as hBtn) {
            <button 
              type="button" 
              class="header-btn"
              [disabled]="hBtn.disabled"
              [title]="hBtn.tooltip || ''"
              (click)="onClickHeaderButton()">
              @if(hBtn.icon) {
                <so-svg-icon-ui [name]="hBtn.icon" color="--so-gray-thick" [size]="18"></so-svg-icon-ui>
              }
              <span>{{ hBtn.text }}</span>
            </button>
          }
          @if(showButtonFullscreen()) {
            <button type="button" class="fullscreen-btn" (click)="changeScreen()">
              <so-svg-icon-ui name="fullscreen" color="--so-gray-thick" [size]="20"></so-svg-icon-ui>
            </button>
          }
        </div>
      } @else {
        <div class="chat-ms_calls">
          @if(showButtonFullscreen()) {
            <button type="button" class="fullscreen-btn" (click)="changeScreen()">
              <so-svg-icon-ui name="fullscreen" color="--so-gray-thick" [size]="20"></so-svg-icon-ui>
            </button>
          }
        </div>
      }
    </div>
  }

  <div class="chat-ms_body">
    <div [class]="'chat-ms_body-container ' + theme()">
      <div class="chat-ms_contain-chats" [class.w-100]="!conversations()?.length">
        <div class="chat-ms_day-message">
          <div class="chat-ms_messages" [class.align-items-center]="!conversations()?.length">
            @for (conversation of conversations(); let i = $index; track i) {
              <p class="date" [style]="textStyle()">{{ isTodayOrYesterday(conversation.blockDates.toString()) }}</p>
              @for (message of conversation.messages; let j = $index; track j) {
                @if (enableCarousel()) {
                  @if(message.carousel?.length) {
                    <so-carousel-message-ui [message]="message" (buttonClicked)="onCarouselButtonClick($event)"></so-carousel-message-ui>
                  } @else {
                    <ng-container *ngTemplateOutlet="messageTemplate; context: { $implicit: message, index: j }"></ng-container>
                  }
                } @else {
                  <ng-container *ngTemplateOutlet="messageTemplate; context: { $implicit: message, index: j }"></ng-container>
                }
              }
            } @empty {
              <div class="chat-ms_content-message" style="margin-top: 15px; min-width: 14rem;">
                <div class="message from system w-100">
                  <p class="text-center" [style]="textStyle()">{{ !isLoading() ? texts().noMessages : texts().loadingMessages }}</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <span #chatBottom></span>
  </div>

  @if(showButtonBarActions()) {
    <div class="chat-ms_bar_actions">
      @if(showEmojis()) {
        <so-emojis-ui
          (emojiSelected)="addEmoji($event)"
          [scale]="0.8"
          [disabled]="disabledButtonsAction()"
          [position]="emojiDisplayPosition()"
          [excludedEmojis]="excludedEmojis()">
        </so-emojis-ui>
      }
      @if(showVariables() || showAttachImages()) {
        <button type="button" class="attach-btn" #popoverButton [disabled]="disabledButtonsAction()" (click)="togglePopover($event)">
          <so-svg-icon-ui name="attach_file" color="--so-gray-thick" [size]="18"></so-svg-icon-ui>
        </button>
        @if(showPopover()) {
          <div class="popover" [class.variables-view]="activePopoverView() === 'variables'">
            @if(activePopoverView() === 'variables') {
              <div style="height: 120px; overflow-y: auto; overflow-x: hidden;">
                <ul class="popover-list">
                  @for (item of itemsVariables(); track $index) {
                    <li (click)="selectVariable(item.key.toString())">
                      {{ item.value }}
                    </li>
                  }
                </ul>
              </div>
            } @else if (activePopoverView() === 'photos') {
              <input type="file" [attr.accept]="fileInputAccept()">
            } @else {
              <ul class="popover-list">
                @if(showAttachImages()) {
                  <li (click)="triggerFileInput()">
                    <so-svg-icon-ui name="image" [size]="18"></so-svg-icon-ui>
                    {{ texts().photos }}
                    <input type="file" [attr.accept]="fileInputAccept()" style="display: none;" #fileInput (change)="handlePhotoUpload($event)">
                  </li>
                }
                @if(showVariables()) {
                  <li (click)="switchPopover('variables')">
                    <so-svg-icon-ui name="data_object" [size]="18"></so-svg-icon-ui>
                    {{ texts().variables }}
                  </li>
                }
              </ul>
            }
          </div>
        }
      }
    </div>
  }

  @if(showFooter() && showFooterMessage()) {
    <div class="chat-ms_footer">
      @if (!footerMessagePart2()) {
        <p [style]="textStyle()">{{ footerMessage() }}</p>
      } @else {
        <p [style]="textStyle()">{{ footerMessagePart1() }} <span>{{ footerMessagePart2() }}</span> {{ footerMessagePart3() }}</p>
      }
    </div>
  }
</div>

<ng-template #messageTemplate let-message let-j="index">
  <div class="chat-ms_content-message" [class.to]="message.senderType === 2">
    <div class="message-stack">
      <div [class.message]="true"
           [class.from]="message.senderType === 1"
           [class.to]="message.senderType === 2"
           [class.from-first]="message.senderType === 1 && j === 0"
           [class.to-first]="message.senderType === 2 && j === 0">
        @if(message.isVoice) {
          @if(message.audioUrl) {
            <div class="audio-container">
              <div class="avatar">
                <img [src]="avatarUrl()" alt="Usuario">
                <div class="audio-icon">
                  <so-svg-icon-ui name="mic" color="--so-white" [size]="12"></so-svg-icon-ui>
                </div>
              </div>
              <div class="audio-controls">
                <button type="button" class="audio-play-btn" (click)="toggleAudio(message.messageID)">
                  <so-svg-icon-ui
                    [name]="isPlaying()[message.messageID] ? 'pause' : 'play_arrow'"
                    color="--whatsapp-audio"
                    [size]="24">
                  </so-svg-icon-ui>
                </button>
                <audio [id]="'audio-' + message.messageID"
                  (timeupdate)="updateProgress($event, message.messageID)"
                  (loadedmetadata)="setDuration(message.messageID)"
                  (ended)="onAudioEnded(message.messageID)">
                  <source [src]="message.audioUrl" type="audio/mpeg">
                </audio>
                <div class="progress-container">
                  <div class="progress-bar" (click)="seekAudio($event, message.messageID)">
                    <div class="progress" [style.width.%]="progress()[message.messageID] || 0"></div>
                  </div>
                  <div class="progress-circle" [style.left.%]="progress()[message.messageID]"></div>
                </div>
                <button type="button" class="transcribe-btn" (click)="toggleTranscription(message)">
                  <so-svg-icon-ui name="text_snippet" color="--so-gray-thick" [size]="18"></so-svg-icon-ui>
                </button>
              </div>
            </div>
          }
          @if(message.showTranscription) {
            <div [innerHTML]="cleanMessage(message.messageText)" class="messages-format-text"></div>
          }
        } @else {
          @for (part of splitMessage(message.messageText); track $index) {
            @if(containtGoogleUrl(part)) {
              <iframe width="100%" height="200" frameborder="0" style="border:0" [src]="sanitizeUrl(part)" allowfullscreen></iframe>
            } @else {
              @if(message.urlAttach) {
                <div class="message-url-attach preview-image-container">
                  <img [src]="message.urlAttach" alt="Attachment" class="attachment-image" />
                  @if(showBtnRmImage()) {
                    <button type="button" class="remove-image-btn" (click)="onClickRemoveImage()">✕</button>
                  }
                </div>
              }
              @if(!message.isVoice) {
                <div [innerHTML]="getSafeMessage(message.messageText)" class="messages-format-text"></div>
              }
            }
          }
        }
        <div class="d-flex justify-content-between">
          @if(message.isVoice && message.audioUrl) {
            <span class="remaining-time">{{ audioDuration()[message.messageID] || '0:00' }}</span>
          }
          <p class="hours-view-message" [style.padding-right]="message.isVoice ? '20px' : '0px'" [style]="textStyle()">
            {{ message.date | date: 'hh:mm a' }}
            <mat-icon [class.see-message-whats]="message.read">check</mat-icon>
            <mat-icon [class.see-message-whats]="message.read">check</mat-icon>
          </p>
        </div>
      </div>
      @if(message.optIn === true && enableOptIn() && !message.isVoice && !message.audioUrl) {
        <div class="optin-actions"
             [class.optin-actions-from]="message.senderType === 1"
             [class.optin-actions-to]="message.senderType === 2">
          <button type="button" class="optin-btn">
            {{ message.optInButtons?.[0] ?? 'Si' }}
          </button>
          <button type="button" class="optin-btn">
            {{ message.optInButtons?.[1] ?? 'No' }}
          </button>
        </div>
      }
    </div>
  </div>
</ng-template>
